export default __webpack_public_path__ + "static/media/spiral-ducts.fc5a38af.jpg";